import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Map, fromJS } from 'immutable'
import { ScriptElement } from '../../Main/ScriptElement'
import { formatStyleText } from '../../../constants/addStyleClasses'
import { getElementDataRoot } from '../../../constants/getElementDataRoot'
import { getStripRootMeta, getFormStyles } from './ProjectStyles'
import { getFormFieldElementStyles } from './FormFieldStyle'
import { usePageElementPosition } from '../../../hooks/useWidgetComponent'
import { toUnits } from '../../../constants/toUnits'
import { shallowEqual } from 'react-redux'

function ProjectDeviceStylesComponent({ width, layoutMode }) {
  try {
    const isRTL = useSelector((state) => state.getIn(['project', 'Settings', 'isRTL'], false))
    const pageID = useSelector((state) => state.getIn(['page']))
    let IsConfiguredDevice = useSelector((state) => {
      if (state.get('page') == 'signin') {
        return state.getIn(['project', 'Settings', 'styles', 'SmartVLoginPage', 'IsConfiguredDevice'], Map())
      } else {
        return state.getIn(['pages', state.get('page'), 'Props', 'IsConfiguredDevice'], Map())
      }
    })

    IsConfiguredDevice = IsConfiguredDevice.set('lg', true)

    const formField = useSelector((state) => state.getIn(['project', 'Settings', 'theme', 'FormField'], Map()))
    const defaultTheme = formField
    const stripRoot = useSelector(getStripRootMeta, shallowEqual)
    const footerHeight = useSelector((state) =>
      state.getIn(['project', 'Settings', 'theme', 'lg', 'Footer', 'root', 'height'], '')
    )
    const pcDesktopRoot = useSelector(
      (state) =>
        toUnits(
          state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'width'], '1367'),
          state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'widthUnit'], 'px')
        ),
      shallowEqual
    )
    const pcDesktopRootUnit = useSelector(
      (state) => state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', 'root', 'widthUnit'], 'px'),
      shallowEqual
    )
    let pageWidth = useSelector((state) =>
      state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'width'])
    )
    const pageWidthUnit = useSelector((state) =>
      state.getIn(['project', 'Settings', 'theme', 'lg', 'Page', state.get('page'), 'widthUnit'])
    )

    try {
      let rootPageSize = parseInt(pcDesktopRoot)
      let specPageSize = parseInt(pageWidth)
      let pageUnit
      if (specPageSize && !isNaN(specPageSize)) {
        pageWidth = specPageSize
        pageUnit = pageWidthUnit
      } else if (rootPageSize && !isNaN(rootPageSize)) {
        pageWidth = rootPageSize
        pageUnit = pcDesktopRootUnit
      }

      if (pageWidth && pageUnit !== 'px') {
        pageWidth = null
      }
    } catch (err) {}

    const projectFormElements = useSelector((state) =>
      state
        .getIn(['project', 'Settings', 'elements'], Map())
        .filter((elem) => ['FormField', 'Search', 'AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')))
        .reduce((r, elem) => {
          const ref = elem.getIn(['props', 'styleRef'])
          const style = state
            .getIn(['project', 'Settings', 'styles', ref], Map())
            .set(
              'control',
              elem.get('type') === 'Search'
                ? 'search'
                : ['AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1
                  ? _.camelCase(elem.get('type'))
                  : elem.getIn(['props', 'control'], 'text')
            )
          return r.set(ref, style)
        }, Map())
    )
    const pageFormElements = useSelector((state) =>
      state
        .getIn(['pages', state.get('page'), 'Props', 'elements'], Map())
        .filter((elem) => ['FormField', 'Search', 'AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')))
        .reduce((r, elem) => {
          const ref = elem.getIn(['props', 'styleRef'])
          const style = state
            .getIn(['pages', state.get('page'), 'Props', 'styles', ref], Map())
            .set(
              'control',
              elem.get('type') === 'Search'
                ? 'search'
                : ['AddressFinder', 'ExternalLookup'].indexOf(elem.get('type')) !== -1
                  ? _.camelCase(elem.get('type'))
                  : elem.getIn(['props', 'control'], 'text')
            )
          return r.set(ref, style)
        }, Map())
    )

    let elementStyles = useSelector((state) => state.getIn(['pages', pageID, 'Props', 'styles'], Map()))
    let projectElementStyles = useSelector((state) => state.getIn(['project', 'Settings', 'styles'], Map()))

    const pageElements = useSelector((state) => state.getIn([...getElementDataRoot(pageID), 'elements'], Map()))
    const projectElements = useSelector((state) => state.getIn([...getElementDataRoot('project'), 'elements'], Map()))

    let resultStyles = {}
    IsConfiguredDevice.map((configuredDevice, layoutMode) => {
      if (!configuredDevice) {
        return true
      }
      if (!resultStyles[layoutMode]) {
        resultStyles[layoutMode] = {}
      }

      const stylesList = elementStyles
        .map((style, key) => ({ style, key }))
        .toList()
        .toJS()
      let chunks = []
      const chunkCount = Math.ceil(stylesList.length / 25)
      _.times(chunkCount, (n) => {
        let styles = []
        stylesList.slice(n * 25, (n + 1) * 25).map((uid) => {
          styles.push(uid.key)
        })

        chunks.push(styles)
      })

      _.each(chunks, (chunk, index) => {
        let key = `${pageID}${chunk.join('_')}`
        let text = []
        let styles = _.reduce(chunk, (r, v) => ({ ...r, [v]: elementStyles.get(v, Map()) }), {})

        _.each(styles, (style) => {
          IsConfiguredDevice.map((isConfigured, key) => {
            if (isConfigured && !style.get(key)) {
              style = style.setIn(
                [key],
                fromJS({
                  root: {},
                })
              )
            }
          })
        })

        _.each(styles, (style, uid) => {
          if (uid === 'Footer' || style.get('type') === 'Footer') {
            if (!style.getIn([layoutMode, 'root', 'height'])) {
              style = style.setIn([layoutMode, 'root', 'height'], footerHeight)
            }
            if (!style.getIn([layoutMode, 'row0'])) {
              style = style.setIn([layoutMode, 'row0'], footerHeight)
              style = style.setIn([layoutMode, 'row0Unit'], 'px')
            }
          }
          text.push(
            formatStyleText(`ft--${uid}`, style, layoutMode, stripRoot, uid, true, isRTL) +
              ` .ft--component-wrap.ft--pos--${uid}, .ft--component-wrap.ft--${uid}--root { opacity: unset; }`
          )
        })
        resultStyles[layoutMode][key] = text.join('')
      })

      // elementStyles.map((val, uid) => {
      //     let style = elementStyles.getIn([uid], Map())
      //     IsConfiguredDevice.map((isConfigured, key) => {
      //         if (isConfigured && !style.get(key)) {
      //             style = style.setIn([key], fromJS({
      //                 root: {

      //                 }
      //             }))
      //         }
      //     })
      //     resultStyles[layoutMode][uid] = formatStyleText(`ft--${uid}`, style, layoutMode, stripRoot, uid, true, isRTL) + ` .ft--component-wrap.ft--pos--${uid} { opacity: unset; }`;
      // })
      projectElementStyles.map((val, uid) => {
        let style = projectElementStyles.getIn([uid])
        IsConfiguredDevice.map((isConfigured, key) => {
          if (isConfigured && !style.get(key)) {
            style = style.setIn(
              [key],
              fromJS({
                root: {},
              })
            )
          }
        })
        resultStyles[layoutMode][uid] =
          formatStyleText(`ft--${uid}`, style, layoutMode, stripRoot, uid, true, isRTL) +
          ` .ft--component-wrap.ft--pos--${uid}, .ft--component-wrap.ft--${uid}--root { opacity: unset; }`
      })

      resultStyles[layoutMode]['formFieldproject'] = String(
        projectFormElements.map(getFormFieldElementStyles(layoutMode, defaultTheme)).toList().join('')
      ).trim()
      resultStyles[layoutMode]['formFieldpage'] = String(
        pageFormElements.map(getFormFieldElementStyles(layoutMode, defaultTheme)).toList().join('')
      ).trim()

      let pagePosition = '',
        projectPosition = ''
      pageElements.map((_, uid) => {
        const { position, vis, extra, extraKey, size } = usePageElementPosition(uid, pageID, true, layoutMode)
        let style = ''
        if (String(position).trim()) {
          style += `.ft--pos--${uid}{${String(position).trim()}}`
        }
        if (String(vis).trim()) {
          style += `.ft--vis--${uid}{${String(vis).trim()}}`
        }
        if (extraKey && extra) {
          style += `.ft--pos--${uid} ${extraKey}{${String(extra).trim()}}`
        }
        if (size) {
          style += size
        }
        pagePosition += style.replace(/\r|\n|[\s]{2,}/g, '')
      })

      projectElements.map((_, uid) => {
        const { position, vis, size } = usePageElementPosition(uid, 'project', true, layoutMode)
        let style = `.ft--pos--${uid} {
                    ${position}
                }
                .ft--vis--${uid} {
                    ${vis}
                }${size ? size : ''}`.replace(/\r|\n|[\s]{2,}/g, '')
        projectPosition += style
      })

      resultStyles[layoutMode][`ft-position`] = pagePosition
      resultStyles[layoutMode][`ft-project-position`] = projectPosition
    })
    if (layoutMode === 'lg' && pageWidth) {
      resultStyles.pageWidth = pageWidth
    }
    return (
      <ScriptElement
        uid={'switch-devices'}
        scriptText={`window.compiledDevicesStyle = ${JSON.stringify(resultStyles)}`}
      />
    )
  } catch (err) {
    console.error(err)
    return null
  }
}

export const ProjectDeviceStyles = React.memo(ProjectDeviceStylesComponent)
